// export const server = "http://localhost:8000";
export const server = "https://adongocarrentalandhirecoserver.vercel.app";
